import { useState, useEffect, useCallback } from 'react';
import { leaveService } from '../services/leaveService'; 

export const usePendingLeavesCount = () => {
  const [count, setCount] = useState(0);

  const fetchCount = useCallback(async () => {
    try {
      const data = await leaveService.getLeaveRequests();
      const results = Array.isArray(data) ? data : data.results || [];
      const pending = results.filter((r: any) => ['submitted', 'pending'].includes(r.status)).length;
      setCount(pending);
    } catch {
      setCount(0);
    }
  }, []);

  useEffect(() => {
    fetchCount();
    window.addEventListener('leaveStatusUpdated', fetchCount);
    return () => {
      window.removeEventListener('leaveStatusUpdated', fetchCount);
    };
  }, [fetchCount]);

  return count;
};